import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';

import Portfolios from './Components/Portfolios';
import Templates from './Components/Templates';

const Contracts = () => {
  const tabs = [
    {
      label: 'Plantillas',
      component: <Templates />,
      path: 'templates',
    },
    {
      label: 'Portafolios',
      component: <Portfolios />,
      path: 'portfolios',
    },
  ];
  return (
    <EnhancedTab
      tabType="secondary"
      startValue={0}
      tabs={tabs}
      onTabChange={() => {}}
    />
  );
};

export default Contracts;
